import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { addGroupOrder } from '../../actions/orderActions'
import DynamicColor from '../../components/common/dynamic-color'
import Button from '../../components/elements/Button'
import FormatCurrency from '../../components/elements/FormatCurrency'
import { COLOR_NAME, ORDER_METHOD } from '../../constants'
import useTimeWork from '../../hooks/useTimeWork'
import { canAddMoreGroup as canAddMoreGroupSelector } from '../../selectors/order'

import ListFoodWithGroup from '../order/ListFoodWithGroup'
import FoodInCart from './FoodInCart'
import FoodInCartSubmitted from './FoodInCartSubmitted'
import useOrder from '../../hooks/useOrder'

const OrderDetailsContainer = ({ setStepOrder, stepOrder }) => {
    const { ordering, orderMethod, ordered, deliverPosition } = useSelector(
        state => state.OrderReducer
    )
    const { isOvertime } = useTimeWork()

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const canAddMoreGroup = useSelector(canAddMoreGroupSelector);
    const { validShippingDistance, shippingDistanceMessage, shipMoney, total } = useOrder();

    const showBtnReqPmt =
        orderMethod === ORDER_METHOD.QR_CODE &&
        !ordering.length &&
        !!ordered.length
    const showStartOrder =
        orderMethod !== ORDER_METHOD.QR_CODE &&
        !!ordering.length &&
        stepOrder === 'ordering' &&
        (orderMethod !== ORDER_METHOD.DELIVERY || deliverPosition?.distance === undefined || validShippingDistance)

    const showSummary = !!ordering.length || !!ordered.length

    const handleRequestPayment = () => {}
    const handleStartOrder = () => setStepOrder('submit')
    const handleAddGroupOrder = () => dispatch(addGroupOrder())

    return (
        <div className="order-details">
            {showSummary ? (
                <>
                    <div className="order-details-list">
                        {ordered.map((food, index) => (
                            <FoodInCartSubmitted
                                food={food}
                                key={`ordered-${index}`}
                            />
                        ))}
                        {/* {ordering.map((food, index) => (
                            <FoodInCart
                                food={food}
                                key={`ordering-${index}`}
                                indexInCart={index}
                                editable
                            />
                        ))} */}
                        {/* {renListFood()} */}

                        <ListFoodWithGroup
                            listFood={ordering}
                            renderFood={(food, i) => (
                                <FoodInCart
                                    food={food}
                                    key={`ordering-${food.groupOrder}-${food.foodDetails?.id}`}
                                    indexInCart={i}
                                    editable
                                />
                            )}
                        />

                        {canAddMoreGroup && (
                            <div className="text-center mt-4">
                                <Button small onClick={handleAddGroupOrder}>
                                    {t('cartDesktop.btnAddGroupOrder')}
                                </Button>
                            </div>
                        )}
                    </div>
                    <div className="line" />
                    <div className="order-details-summary">
                        {!!shipMoney && (
                            <div className="flex-between ship-money-desk">
                                <div className="label">
                                    {t('cartDesktop.lbShippingPrice')}
                                </div>
                                <div className="value">
                                    <FormatCurrency amount={shipMoney} />
                                </div>
                            </div>
                        )}
                        <div className="flex-between total">
                            <div className="label">
                                {t('cartDesktop.lbTotalAmount')}
                            </div>
                            <div className="value">
                                <FormatCurrency amount={total} />
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="text-center p-6"
                >
                    {t('cartDesktop.lbCartEmpty')}
                </DynamicColor>
            )}

            {!validShippingDistance && (
                <div className="label-3 min-value-require">
                    {shippingDistanceMessage}
                </div>
            )}

            {(showBtnReqPmt || showStartOrder) && (
                <div className="order-details-submit text-center">
                    {showBtnReqPmt && (
                        <Button
                            disabled={isOvertime}
                            onClick={handleRequestPayment}
                            large
                        >
                            {t('cartDesktop.btnRequestPayment')}
                        </Button>
                    )}
                    {showStartOrder && (
                        <Button fullWidth onClick={handleStartOrder}>
                            <b>{t('cartDesktop.btnStartOrder')}</b>
                        </Button>
                    )}
                </div>
            )}
        </div>
    )
}

export default OrderDetailsContainer
